import React, { PureComponent } from 'react';
import { View, Dimensions, ActivityIndicator } from 'react-native';
import { PALETTE } from '../../../../../../src/constants';
import { createContainer } from '@dbk-legacy/muster/react';
import styles from '../../../../../../src/screens/income-history/asset-transaction/transaction.style';
import { Large, Small } from '@dbk/ui-text';
import ValueHeader from '../../../../../../src/components/common/value-header';
import TableRow from '../../../../../../src/components/common/table-row';
import ScrollableLayout from '../../../../../../src/components/common/scrollable-layout';
import { Currency } from '../../../../../../src/components/common/number';
import Accordion from '../../../../../../src/components/common/accordion';
import { INCOME_EXPENSE } from '../../../../../../src/constants';
import TransactionHistoryTable from '../_transaction-table-tablet';
import ProductContent from '../_product-content';
import SimpleDate from '../../../../../../src/components/common/date';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
import SortingHeader from '../../../../../../src/components/common/sorting-header';
import ResponsiveText from '../../../../../../src/components/common/text/responsive-text';

class assetTransaction extends PureComponent {
  constructor(props) {
    super(props);
    const { income } = this.props;
    this.state = {
      showCalendar: false,
      timeline: 0,
      summary: 0
    };
  }

  componentDidMount() {
    const windowPath = window.location.pathname.split("/");
    const asset = windowPath[windowPath.length - 3];
    const summary = windowPath[windowPath.length - 2];
    const title = windowPath[windowPath.length - 1];
    var currentAsset = asset;
    this.setState({
      summary: summary
    });
    this.setState({
      referenceCurrency: this.props.portfolio.referenceCurrency
    });
    this.props.changeStateTitle({ custometitle: currentAsset });
    this.props.income.setIeProdtype(asset);
    // pull the current transation
    this.props.getTransactionHistory();
  }

  componentWillUnmount() {
    this.props.changeStateTitle({ custometitle: "" });
    this.props.clearTransactionList();
  }

  _renderHeader(row) {
    return (
      <View>
        <ResponsiveText style={styles.transactionDesc} numberOfLines={1} minSize="large" testID="Description" >
          {row.ieDesc}
        </ResponsiveText>
        <TableRow>
          <TableRow.Column align="left" >
            <Large>
              <SimpleDate value={row.ieTradeDate} />
            </Large>
          </TableRow.Column>
          <TableRow.Column align="right" >
            <Currency
              renderProps={{
                size: 'Large',
                testID: 'market-value',
              }}
              currency={this.refCurrency}
              value={row.ieTrnAmtRefCcy}
            />
          </TableRow.Column>
        </TableRow>
      </View>
    );
  }

  _renderContent(row) {
    return (
      <ProductContent row={row} />
    );
  }

  _renderTabletTransaction() {
    const windowPath = window.location.pathname.split("/");
    const currentAsset = windowPath[windowPath.length - 3];
    return (
      <TransactionHistoryTable data={this.props.income.transactionHistory} type={currentAsset} currency={this.props.portfolio.referenceCurrency} />
    );
  }

  createTabletStickyHeader(income) {
    let options = [];
    options = this.renderStickyHeader('app.incomehistory.reference', 'app.report.transactionHistory.valueDate', 'app.incomehistory.AmtPosCCy');
    return options;
  }

  renderStickyHeader(...headerItems) {
    let optionItems = ['app.report.transactionHistory.tradeDate', ...headerItems, 'app.incomehistory.netAmt'];
    return optionItems;
  }

  renderAssetList(key, data) {
    let filterProduct = []
    if (data != undefined && data != null) {
      data.map((item, index) => {
        if (key == item.ieProdType) {
          filterProduct.push(item);
        }
      });
    }
  }

  checkEmptyData() {
    const { income, i18n: { messages } } = this.props;
    const dataCount = income.transactionHistory.length;
    if (dataCount == 0) {
      return (
        <View style={styles.notice}>
          <Small>{messages['app.profile.consolidatesetup.dataRes']}</Small>
        </View>
      );
    }
  }

  returnTabletSticyHeader(stickHeader) {
    const { screen, i18n: { messages } } = this.props;
    if (screen.isSmall) {
      return (<SortingHeader
        enabled={false}
        showBorder={false}
        messages={messages}
        currency={this.props.portfolio.referenceCurrency}
        options={[
          { key: 'type', label: "app.incomehistory.date", width: 0.50, isPhone: true, isTablet: true },
          { key: 'Amount', label: "app.incomehistory.netAmt", width: 0.50, isPhone: true, isTablet: true, displayCurrency: true },
        ]}
      />);
    } else {
      return (<SortingHeader
        enabled={false}
        showBorder={false}
        messages={messages}
        currency={this.props.portfolio.referenceCurrency}
        options={[
          {
            key: stickHeader[0],
            label: stickHeader[0],
            width: 1,
            isTablet: true,
            optionStyle: {
              justifyContent: 'flex-start',
            },
          }, {
            key: stickHeader[1],
            label: stickHeader[1],
            width: 1,
            isTablet: true,
            customStyle: true,
            optionStyle: {
              justifyContent: 'flex-end',
              marginRight: 12,
            },
          }, {
            key: stickHeader[2],
            label: stickHeader[2],
            width: 1,
            isTablet: true,
            customStyle: true,
            optionStyle: {
              justifyContent: 'flex-end',
              marginRight: 12,
            },
          }, {
            key: stickHeader[3],
            label: stickHeader[3],
            width: 1,
            isTablet: true,
            customStyle: true,
            optionStyle: {
              justifyContent: 'flex-end',
              marginRight: 12,
            },
          },
          {
            key: stickHeader[4],
            label: stickHeader[4],
            width: 1,
            isTablet: true,
            displayCurrency: true,
            optionStyle: {
              justifyContent: 'flex-end',
              marginRight: 12,
            },
          }
        ]}
      />);
    }
  }

  setTypeColor(val) {
    let oReturn = {
      fill: INCOME_EXPENSE.expense
    }
    if (val >= 0) {
      oReturn.fill = INCOME_EXPENSE.income;
    }
    return (oReturn);
  }

  render() {
    const {
      income,
      app,
      screen: {
        isSmall,
      },
      i18n: { messages }
    } = this.props;
    const stickHeader = this.createTabletStickyHeader(income);
    const deviceInfo = app.global.deviceInfo;

    if (!income.transactionHistory) {
      return (
        <View style={styles.loadingIcon}>
          <ActivityIndicator
            animating
            color={PALETTE.primaryText}
            size="large"
          />
        </View>
      );
    }

    return (
      <div className="asset-positions row flex full-height">
        <ScrollableLayout
          testID="Profile-view"
          header={
            <View style={styles.valueheader}>
              <ValueHeader
                title={messages['app.report.transactionHistory.amount']}
                value={parseFloat(this.state.summary)}
                valueUnit={this.props.portfolio.referenceCurrency}
              />
            </View>
          }

          stickyHeader={this.returnTabletSticyHeader(stickHeader)}
          body={
            <View>
              {isSmall &&
                <Accordion
                  markerStyle={this.setTypeColor(this.state.summary)}
                  sections={this.props.income.transactionHistory}
                  renderHeader={this._renderHeader}
                  renderContent={this._renderContent} />
              }
              {!isSmall &&
                this._renderTabletTransaction()
              }
              {this.checkEmptyData()}
            </View>
          }
        />
      </div>
    );
  }
}

export default createContainer({
  $renderError: () => <Error />,
  $renderLoading: () => <LoadingCircle isPage={true} />,
  $queries: {
    changeStateTitle: { $call: 'ui.change.customtitle' },
    clearTransactionList: { $call: 'income.clearTransactionList' },
    getTransactionHistory: { $call: 'income.getTransactionHistoryCH' },

    portfolio: {
      referenceCurrency: true,
    },
    i18n: {
      messages: true,
    },
    income: {
      transactionHistory: true,
      ieProdtype: true,
      setIeProdtype: {
        $set: 'ieProdtype',
      },
    },
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        }
      }
    },
    screen: {
      width: true,
      height: true,
      isSmall: true,
    },
  },
})(assetTransaction);